<template>
  <v-dialog
    :value="dialog"
    max-width="600px"
    persistent
    @input="$emit('update:dialog', $event)"
  >
    <v-card class="prepare-dialog">
      <v-card-title class="prepare-dialog-header">
        <v-icon large color="white" class="mr-3">
          mdi-alert-circle-outline
        </v-icon>
        <span class="headline white--text">Confirmar Preparo de Estímulos</span>
      </v-card-title>

      <v-card-text class="pt-4 pb-2">
        <div class="mb-3">
          <p class="body-1 mb-2">
            Você está prestes a preparar
            <strong>{{ selectedStimulus.length }}</strong> {{ stimulusLabel }}:
          </p>
          <v-list dense class="stimulus-list elevation-1">
            <v-list-tile
              v-for="stimulus in selectedStimulus"
              :key="stimulus.id"
              class="stimulus-item"
            >
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-medium">{{
                  stimulus.name
                }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--secondary">
                  {{ getDebtBaseName(stimulus) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon :color="stimulus.active_at ? 'success' : 'grey'">
                  mdi-check-circle
                </v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>

        <v-alert
          v-if="hasInvalidPrepareDay"
          :value="true"
          type="error"
          class="mt-3 mb-0"
          icon="mdi-calendar-alert"
        >
          <div class="font-weight-bold mb-2">
            Atenção: Árvores não funcionais para hoje
          </div>
          <div class="body-2">
            As seguintes estruturas de árvore não estão configuradas para
            preparar no dia de hoje:
          </div>
          <ul class="mt-2 body-2">
            <li v-for="tree in invalidTrees" :key="tree" class="mb-1">
              <strong>{{ tree }}</strong>
            </li>
          </ul>
          <div class="mt-2 body-2 font-weight-medium">
            Deseja preparar mesmo assim?
          </div>
        </v-alert>

        <v-alert
          v-else
          :value="true"
          type="info"
          class="mt-3 mb-0"
          icon="mdi-information-outline"
        >
          <div class="body-2">
            Os estímulos selecionados serão enviados para preparação.
          </div>
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-4 py-3">
        <v-spacer></v-spacer>
        <v-btn flat large class="px-4" @click="$emit('update:dialog', false)">
          Cancelar
        </v-btn>
        <v-btn
          color="accent"
          large
          depressed
          class="px-4 elevation-2"
          @click="$emit('confirm-prepare')"
        >
          <v-icon left>mdi-check</v-icon>
          Confirmar Preparo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogConfirmPrepare",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedStimulus: {
      type: Array,
      default() {
        return [];
      },
    },
    hasInvalidPrepareDay: {
      type: Boolean,
      default: false,
    },
    invalidTrees: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    stimulusLabel() {
      return this.selectedStimulus.length === 1 ? "estímulo" : "estímulos";
    },
  },
  methods: {
    getDebtBaseName(stimulus) {
      if (!stimulus || !stimulus.debt_node || !stimulus.debt_node.debt_base) {
        return "";
      }

      return stimulus.debt_node.debt_base.name;
    },
  },
};
</script>

<style scoped>
.prepare-dialog .prepare-dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 24px;
}

.prepare-dialog .stimulus-list {
  max-height: 250px;
  overflow-y: auto;
  border-radius: 4px;
  background: #fafafa;
}

.prepare-dialog .stimulus-item {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.prepare-dialog .stimulus-item:last-child {
  border-bottom: none;
}

.prepare-dialog .stimulus-item:hover {
  background-color: #f5f5f5;
}

.prepare-dialog .v-alert {
  border-radius: 8px;
}

.prepare-dialog .v-alert ul {
  padding-left: 20px;
}

.prepare-dialog .v-card__actions {
  background-color: #fafafa;
}
</style>
